import React from 'react';

export type PrivacyFieldErrorHintProps = {
  privacyCheckErrorTip?: string | null;
  /** 无配置或空白时的兜底文案 */
  fallback?: string;
  className?: string;
};

export function getPrivacyFieldErrorMessage(privacyCheckErrorTip: string | null | undefined, fallback: string): string {
  return typeof privacyCheckErrorTip === 'string' && privacyCheckErrorTip.trim()
    ? privacyCheckErrorTip.trim()
    : fallback;
}

/** 隐私勾选外置错误提示（弹窗/嵌入式等多处复用），样式见 App.css `.cartx-privacy-field-error-hint` */
export function PrivacyFieldErrorHint({ privacyCheckErrorTip, fallback = 'This field is required.', className }: PrivacyFieldErrorHintProps) {
  return (
    <div className={['cartx-privacy-field-error-hint', className].filter(Boolean).join(' ')}>
      {getPrivacyFieldErrorMessage(privacyCheckErrorTip, fallback)}
    </div>
  );
}
